<template>
  <ModalForm
    title="Add Person"
    :show="props.show"
    @submit="submit"
    @close="emit('close')"
    :processing="form.processing"
    button="Add"
  >
    <div class="space-y-4">
      <div>
        <LabelErrorContainer
          label="Person"
          :error="form.errors['user.id'] || form.errors['user.name']"
        >
          <UserPicker v-model="form.user" allowNew />
        </LabelErrorContainer>
        <InputHelpText
          >Search for someone who already has an account, or type a new name to
          create one.</InputHelpText
        >
      </div>

      <div v-if="form.user && (!form.user.id || !form.user.email)">
        <InputGroup
          v-model="form.email"
          type="email"
          label="Email"
          :error="form.errors.email"
        />
        <InputHelpText
          >A login will be created and you'll be shown a password to send
          them.</InputHelpText
        >
      </div>

      <div>
        <LabelErrorContainer label="Role" :error="form.errors.type">
          <SelectSimpleNative v-model="form.type" :error="form.errors.type">
            <option v-for="type in props.types" :key="type" :value="type">
              {{ roleLabel(type) }}
            </option>
          </SelectSimpleNative>
        </LabelErrorContainer>
        <InputHelpText>{{ roleMeta[form.type].description }}</InputHelpText>
      </div>

      <div v-if="form.type === 'flyer' || form.type === 'guest'">
        <LabelErrorContainer label="Bills To" :error="form.errors.owner_id">
          <SelectSimpleNative
            v-model="form.owner_id"
            :error="form.errors.owner_id"
          >
            <option :value="null">No specific owner</option>
            <option
              v-for="owner in props.owners"
              :key="owner.id"
              :value="owner.id"
            >
              {{ owner.name }}
            </option>
          </SelectSimpleNative>
        </LabelErrorContainer>
        <InputHelpText
          >Trips this person schedules are allocated to this
          owner.</InputHelpText
        >
      </div>
    </div>
  </ModalForm>
</template>

<script setup>
import ModalForm from '@/Common/Overlays/Modals/ModalForm.vue'
import LabelErrorContainer from '@/Common/Forms/Inputs/LabelErrorContainer.vue'
import InputGroup from '@/Common/Forms/Inputs/InputGroup.vue'
import InputHelpText from '@/Common/Forms/Inputs/InputHelpText.vue'
import SelectSimpleNative from '@/Common/Forms/SelectMenus/SelectSimpleNative.vue'
import UserPicker from '../UserPicker.vue'
import { useForm } from '@inertiajs/inertia-vue3'
import { roleMeta, roleLabel } from './roles'

const props = defineProps({
  show: Boolean,
  plane: Object,
  owners: Array,
  types: Array,
})

const emit = defineEmits(['close'])

const form = useForm({
  user: null,
  email: null,
  type: 'flyer',
  owner_id: null,
})

function submit() {
  form.post(route('planes.users.store', props.plane), {
    preserveScroll: true,
    onSuccess: () => {
      emit('close')
      form.reset()
    },
  })
}
</script>
